import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChannelLocal = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	fill: "currentColor",
	stroke: "#2E2E2E",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		r: 8,
		cx: 10,
		cy: 10
	})
});
export default SvgChannelLocal;
